<template>
    <div class="list-packages-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formcat" class="formcat">
                <div class="row">
                    <div class="col-12 col-sm-4 offset-3">
                        <input type="text" class="al-inputs required scr-input" placeholder="Nombre" v-model="cat.name"
                               id="nombre"/>
                    </div>
                    <div class="col-12 col-sm-2">
                        <button type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-md-2">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">
                                {{ tituloBtn }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="catArray">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Categorias)="{item}">
                                {{ item.name }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {categoryLaboratoryService} from "../../Services/CategoryLaboratory.service";

export default {
    name: "Category-List",
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            isBusy: false,
            fields: [
                {key: 'Categorias'},
                {key: 'Acciones'}
            ],
            cat: {
                name: '',
            },
            catArray: [],
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {

            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.cat = data
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async guardar() {
            //console.log('guardando');
            let resp = '';
            let respVal = this.valFormulariosV3('formcat');
            if (respVal) {
                //console.log('paso la validación');

                //actualizando
                if (this.modificar) {
                    // console.log('upgrade el paquete');
                    resp = await categoryLaboratoryService.updateOne(this.cat.id, this.cat);
                    this.modificar = false;
                } else {
                    //console.log('insertando el paquete');
                    resp = await categoryLaboratoryService.saveOne(this.cat);
                }

            }

            this.setEmpty();
            this.getAlert(resp.process);
            await this.index();

        },
        async onClickDelete(id) {
            let resp = '';
            resp = await categoryLaboratoryService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            let tempArray = [];
            this.isBusy = true;
            let resp = await categoryLaboratoryService.getMany();

            resp.forEach(function (item) {
                tempArray.push({'id': item.id, 'name': item.name});
            });

            this.catArray = tempArray;
            this.isBusy = false;
        },
        setEmpty() {
            this.cat = {
                name: '',
            }
        }

    },
    mounted() {
        this.index();
    },
}
</script>

